import { ComponentProps, FC } from 'react'
import { IconWrapper } from '../wrapper'

export const IconArchiveLight: FC<ComponentProps<typeof IconWrapper>> = props => {
  const { size = 20, color = 'currentColor' } = props
  return (
    <IconWrapper {...props} size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.33332 6.66667L3.33332 15.8333C3.33332 16.2754 3.50892 16.6993 3.82148 17.0118C4.13404 17.3244 4.55796 17.5 4.99999 17.5L15 17.5C15.442 17.5 15.8659 17.3244 16.1785 17.0118C16.4911 16.6993 16.6667 16.2754 16.6667 15.8333L16.6667 6.66667M8.33332 10L11.6667 10M2.49999 2.5L17.5 2.5C17.9602 2.5 18.3333 2.8731 18.3333 3.33333L18.3333 5.83333C18.3333 6.29357 17.9602 6.66667 17.5 6.66667L2.49999 6.66667C2.03975 6.66667 1.66666 6.29357 1.66666 5.83333L1.66666 3.33333C1.66666 2.8731 2.03975 2.5 2.49999 2.5Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconWrapper>
  )
}
